// Vendors
import { StorageLocalEnumeration } from '@gruposantander/opbpay-ui-core-models';
import { MessageFormatElement } from 'react-intl';
// Constants
import { CURRENT_LOCALE_KEY } from './constants/internationalization.handlers.constants';
// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
// Event Handlers
import { newTranslationsVersionAvailable } from './utils/internationalization.handlers.utils';
// Types
import { InternationalizationBuilderReturnHandlersType } from './types/internationalization-builder-return.handlers.type';
import { InternationalizationBuilderHandlersType } from './types/internationalization-builder.handlers.type';
import { InternationalizationDownloadHandlersType } from './types/internationalization-download.handlers.type';
// Utilities
import {
  fetchLanguageResolver,
  fetchLanguagesConfigurationResolver,
} from '../resolvers/internationalization.resolvers';

const updateTranslationsInformationFlag =
  () =>
  (prevFlags: AppInformationNeedEnumeration[]): AppInformationNeedEnumeration[] => [
    ...prevFlags,
    AppInformationNeedEnumeration.TRANSLATIONS,
  ];

const downloadNewLanguageMessages = async ({
  response,
  setError,
  setFetching,
  setInformationFlags,
  setTranslations,
}: InternationalizationDownloadHandlersType): Promise<void> => {
  const { language, downloadUrl, lastChangedVersion } = response;

  if (!downloadUrl) {
    setError(AppErrorEnumeration.UNKNOWN_ERROR);
    setFetching(false);
  }

  const [entries, error] = await fetchLanguageResolver(downloadUrl || '');

  if (error) {
    setFetching(false);
    setError(AppErrorEnumeration.UNKNOWN_ERROR);
  } else {
    setTranslations(entries as Record<string, MessageFormatElement[]>);
    localStorage.setItem(StorageLocalEnumeration.TRANSLATIONS, JSON.stringify(entries));
    localStorage.setItem(StorageLocalEnumeration.VERSION, lastChangedVersion);
    localStorage.setItem(StorageLocalEnumeration.LANGUAGE, language);
    setInformationFlags(updateTranslationsInformationFlag());
    setFetching(false);
  }
};

const fetchTranslationsHandler = async ({
  locale,
  setError,
  setFetching,
  setInformationFlags,
  setTranslations,
}: InternationalizationBuilderHandlersType): Promise<void> => {
  setFetching(true);

  const [response, error] = await fetchLanguagesConfigurationResolver(locale);

  if (error) {
    setError(AppErrorEnumeration.UNKNOWN_ERROR);
  } else if (response && newTranslationsVersionAvailable(response)) {
    await downloadNewLanguageMessages({
      response,
      setFetching,
      setError,
      setInformationFlags,
      setTranslations,
    });
    localStorage.setItem(CURRENT_LOCALE_KEY, locale);
  } else {
    setInformationFlags(updateTranslationsInformationFlag());
    setFetching(false);
  }
};

const InternationalizationHandlers = (
  props: InternationalizationBuilderHandlersType
): InternationalizationBuilderReturnHandlersType => ({
  handleFetchTranslations: () => fetchTranslationsHandler(props),
});

export default InternationalizationHandlers;
